const menuItems = [
  { iconType: 'dashboard', linkTarget: 'https://digital.mymax.com', linkName: 'Dashboard' },
  { iconType: 'star', linkTarget: 'https://rewards.plugins.mymax.com', linkName: 'Member Rewards' },
  { iconType: 'receipt', linkTarget: 'https://rewards.plugins.mymax.com/redeem', linkName: 'Redemption Options' },
  { iconType: 'star', linkTarget: 'https://rewards.plugins.mymax.com/getpoints', linkName: 'Get Points' },
  { iconType: 'messages', linkTarget: 'https://digital.mymax.com/messages', linkName: 'Messages' },
  { iconType: 'accounts', linkTarget: 'https://digital.mymax.com/accounts', linkName: 'Accounts' },
  { iconType: 'support', linkTarget: 'https://digital.mymax.com/support', linkName: 'Support' }
];

export default menuItems;